import {
  ACTION_GET_CONTACT_LIST,
  ACTION_GET_CONTACT_LIST_SUCCESS,
} from 'src/redux/actions/contact/contactActions'

const INITIAL_STATE = {
  data: {},
  loading: false,
}

const contactReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_GET_CONTACT_LIST:
      return {
        ...state,
        loading: true,
      }
    case ACTION_GET_CONTACT_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default contactReducer
